const durationDefault = 0.3;
const easeDefault = 'power1.out';
const transitionData = {
  fade: {
    ease: 'sine.inOut',
    closed: {
      autoAlpha: 0,
      duration: 0.4,
    },
    open: {
      autoAlpha: 1,
      ease: 'power3.out',
    },
  },
};

class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.detailsContent = this.summaryToggle.nextElementSibling;
    this.autoClickSelector = this.getAttribute('clickOnOpen');
    this.transition = this.getAttribute('transition') ?? false;
    this.transitionStart = {
      fade: { autoAlpha: 0 },
    };
    this.transitionData = { ...transitionData[this.transition] };

    this.detailsContainer.addEventListener(
      'keyup',
      event => event.code.toUpperCase() === 'ESCAPE' && this.close(),
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this),
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this),
    );
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains('modal-overlay')
    )
      this.close(true);
  }

  setInitialTransitionState() {
    const {
      duration = null,
      ease = null,
      ...initialState
    } = this.transitionData.closed;
    gsap.set(this.detailsContent, initialState);
  }

  animate({ reverse = false, onComplete = null } = {}) {
    const props = reverse
      ? this.transitionData.closed
      : this.transitionData.open;
    if (!props.ease) props.ease = this.transitionData.ease ?? easeDefault;
    if (!props.duration)
      props.duration = this.transitionData.duration ?? durationDefault;
    gsap.to(this.detailsContent, {
      ...props,
      onComplete,
    });
  }

  open(event) {
    if (this.transition) this.setInitialTransitionState();

    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    const open = () => {
      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector('input:not([type="hidden"])'),
      );

      this.autoClickElement ??= document.querySelector(this.autoClickSelector);
      this.autoClickElement?.click();
    };

    if (this.transition) {
      return this.animate({ onComplete: open.bind(this) });
    }

    open();
  }

  close(focusToggle = true) {
    const close = () => {
      removeTrapFocus(focusToggle ? this.summaryToggle : null);
      this.detailsContainer.removeAttribute('open');
      document.body.removeEventListener('click', this.onBodyClickEvent);
      document.body.classList.remove('overflow-hidden');
    };

    if (this.transition) {
      return this.animate({ reverse: true, onComplete: close.bind(this) });
    }

    close();
  }
}

customElements.define('details-modal', DetailsModal);
